import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { LoginForm }   from "./components/LoginForm";
import { Navbar }      from "./components/Navbar";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { CertDashboard } from "./pages/CertDashboard";
import { OwnerDashboard } from "./pages/OwnerDashboard";
import { NftDetails } from "./pages/NftDetails";
import { Verify } from "./pages/Verify";
import { AdminUsers }  from "./pages/AdminUsers";
import { Register }   from "./pages/Register";
import { PartnerApply } from "./pages/PartnerApply";
import { ForgotPassword } from "./pages/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword";
import { EmailVerificationResult } from "./pages/EmailVerificationResult";
import { Claim } from "./pages/Claim";
import { Home } from "./pages/Home";
import { Reassign } from "./pages/Reassign";
import { PartnerApplications } from "./pages/PartnerApplications";
import { Terms } from "./pages/Terms";
import { Privacy } from "./pages/Privacy";
import { Disclaimer } from "./pages/Disclaimer";
import { HelpCenter } from "./pages/HelpCenter";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route path="/register" element={<Register />} /> {}
          <Route path="/partners/apply" element={<PartnerApply />} />
          <Route path="/email-verified" element={<EmailVerificationResult />} />
          <Route path="/claim" element={<Claim />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/cert"   element={<ProtectedRoute><CertDashboard mode="trusted" /></ProtectedRoute>} />
        <Route path="/mint"   element={<ProtectedRoute><CertDashboard mode="user_generated" /></ProtectedRoute>} />
          <Route path="/owner"  element={<ProtectedRoute><OwnerDashboard/></ProtectedRoute>} />
          <Route path="/owner/:numistrailId" element={<OwnerDashboard />} />
          <Route path="/nft/:nftId" element={<NftDetails/>} />
          <Route path="/verify"  element={<ProtectedRoute><Verify/></ProtectedRoute>} />
          <Route path="/admin"  element={<ProtectedRoute><AdminUsers/></ProtectedRoute>} />
          <Route path="/partners"  element={<ProtectedRoute><PartnerApplications/></ProtectedRoute>} />
          <Route path="/reassign" element={<ProtectedRoute><Reassign /></ProtectedRoute>} />
          <Route path="/help" element={<ProtectedRoute><HelpCenter /></ProtectedRoute>} />
          <Route path="/" element={<ProtectedRoute><Home/></ProtectedRoute>} />
          <Route path="*"        element={<Navigate to="/"/>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
